import { Component, OnInit, ViewChild } from '@angular/core';
import { EmailTemplateListComponent } from '../admin/email-template-list.component';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { EmailTemplate } from 'src/app/models/EmailTemplateModel';

@Component({
  selector: 'cw-ci-email-template-dashboard',
  templateUrl: './email-template-dashboard.component.html',
  styleUrls: []
})
export class EmailTemplateDashboardComponent implements OnInit {
  state='LIST';
  selectedEmailTemplate: EmailTemplate;

  @ViewChild(EmailTemplateListComponent) emailTemplateList: EmailTemplateListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) { }

  ngOnInit() {
  }

  showAllEmailTemplates() {
    this.selectedEmailTemplate = undefined;
    this.state = 'LIST'
  }

  onStateChange(event) {
    switch(event.state) {
      case 'CREATE':
        this.selectedEmailTemplate = new EmailTemplate();
        this.state = 'CREATE';
        break;
      case 'SELECT':
      case 'EDIT':
        this.selectedEmailTemplate = event.item;
        this.state = 'EDIT';
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedEmailTemplate = undefined;
        this.state = 'LIST';
        break;
    }
  }
}
